import background from "@/assets/images/homepage/background.png";

interface BannerSectionProps {
  title: string;
}

export const BannerSection = ({ title }: BannerSectionProps) => {
  return (
    <div className="relative flex min-h-[34vh] w-full items-end overflow-hidden px-4 py-8 ph:px-24 ph:py-16 md:min-h-[38vh] md:px-48 lg:px-72 xl:px-96">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${background.src})` }}
      />

      <div className="absolute inset-0 bg-black/35" />
      <div className="absolute inset-0 bg-gradient-to-b from-primary/25 via-primary/20 to-black/65" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_20%,rgba(255,255,255,0.12)_0%,rgba(255,255,255,0)_42%)]" />

      <div className="relative max-w-5xl">
        <p className="mb-3 inline-flex rounded-full border border-white/35 bg-white/10 px-3 py-1 text-[0.65rem] font-semibold uppercase tracking-[0.18em] text-white/90 backdrop-blur-sm ph:text-xs">
          Espace Cadet
        </p>
        <h1 className="text-start text-2xl font-extrabold uppercase text-white [text-shadow:_0_4px_18px_rgb(0_0_0_/_0.55)] ph:text-3xl lg:text-5xl">
          {title}
        </h1>
      </div>
    </div>
  );
};
